<template>
    <div id="main">
        <loader v-if="isLoading"/>
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs"/>

            <div class="novo-categoria">
                <!-- TÍTULO -->
                <h1 class="title">{{ $t('cargo') }}{{ cargo.idusuariocargo != null ?  `: ${cargo.descricao}` : `: ${$t('novo-cargo')}` }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a class="a-inativo">{{$t('admin')}}</a></li>
                        <li><a class="a-inativo">{{$t('colaborador')}}</a></li>
                        <li><a @click="$router.push({ name: 'usuario-cargo-list' })">{{$t('cargo')}}</a></li>
                        <li><a aria-current="page">{{ cargo.idusuariocargo !=null ? cargo.descricao : $t('novo-cargo') }}</a></li>
                    </ul>
                </nav>
                <div class="form-columns-fit mt-3">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input 
                                id="idusuariocargoerpInput"
                                ref="idErpInput"
                                v-model="cargo.idusuariocargoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!cargo.idusuariocargoerp"
                                tooltipLabel="cod-ref"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-7">
                            <v-input 
                                ref="descricaoInput"
                                v-model="cargo.descricao"
                                placeholder="descricao"
                                :maxlength="50"
                                :title="'descricao'"
                                :required="true"
                                :disabled="isEdit || usuarioIntegracao"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!cargo.descricao"
                                uppercase
                                tooltipLabel="info-descricao-cargo"
                            />
                        </div>
                        <div class="column is-3">
                            <vs-select 
                                ref="situacaoSelect" 
                                :selectOnTab="true" 
                                :searchable="false" 
                                :options="situacoes"
                                :disabled="!isEdit || usuarioIntegracao"
                                v-model="cargo.situacao" 
                                class="no-clear"
                                title="situacao"
                                tooltipLabel="info-situacao-cargo"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="redirectToPage">
                        {{ $t('voltar') }}
                    </button>
                    <button v-if="!usuarioIntegracao"
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isSaving">
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterBar from "@/components/shared/Filter";
import cargoService from "@/services/promotor/cliente/CargoService";
import CargoValidation from "@/services/validations/CargoValidation";
import Message from "@/models/Message";

export default {
    components: {
        FilterBar,
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes("USUARIOCARGO"),
            isLoading: false,
            cargo:{
                idusuariocargoerp: '',
                idusuariocargo: '',
                descricao: '',
                situacao: { label: "Ativo", id: 1 },
            },
            situacoes: [{ label: "Inativo", id: 0 }, { label: "Ativo", id: 1 }],
            msgs: [],
            isSaving: false,
            permissao: null,
            isEdit: false,
            isChanged: false,
            validation: null,
            service: new cargoService(this.$http, this.$router),
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('admin', 'colaborador', 'usuario-cargo');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cargo' }
            });
        }

        if (this.$route.params.id && this.$route.params.name != 'usuario-cargo-new') {
            this.isEdit = true
        }
        this.validation = new CargoValidation(this.msgs)
        this.carregarDados();
    },
    methods: {
        carregarDados () {
            this.isLoading = true;

            if(this.isEdit){
                this.loadcargo()
            } else {
                this.cargo.situacao = this.situacoes[1];
            }
            this.isChanged = false;
            this.isLoading = false;
        },
        loadcargo(){
            this.service
                .find(this.$route.params.id)
                .then(cargo => {
                    this.mapcargo(cargo.content)
                    this.isChanged = false;
                })
        },
        save() {
            this.isLoading = true;
            let cargoTemp = this.mapOnSave(this.cargo);
                cargoTemp.descricao = this.mapTosave(cargoTemp.descricao);
            if (this.validation.validate(cargoTemp, this.$refs)) {
                this.isSaving = true;
                this.service.save(cargoTemp)
                    .then(value => {
                        if (value.content) {
                            let msg = this.$t("msg-save-sucesso-n", { n: this.$t("cargo") });
                            this.msgs.push(new Message("success", msg, true, false));
                            this.redirectToPage();
                        } else {
                            this.isSaving = false;
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.message && this.$te(e.body.message)) {
                            let message = e.body.message;
                            let msgErro;
                            if (message == "msg-codigo-duplicado-n") {
                                msgErro = this.$t(e.body.message, { n: cargoTemp.idusuariocargoerp });
                            } else {
                                msgErro = this.$t(message);
                            }
                            this.msgs.push(new Message("alert", msgErro, true, false));
                        } else {
                            this.msgs.push(
                                new Message("error", "msg-problema-realizar-acao", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else{
                this.isSaving = false;
                this.isLoading = false;
                this.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
            }
        },
        mapOnSave (cargo) {
            return {
                idusuariocargo: cargo.idusuariocargo,
                idusuariocargoerp: cargo.idusuariocargoerp,
                descricao: cargo.descricao,
                situacao: cargo.situacao.id
            }
        },
        mapcargo(cargo){
            this.cargo.idusuariocargo = cargo.idusuariocargo;
            this.cargo.idusuariocargoerp = cargo.idusuariocargoerp;
            this.cargo.descricao = cargo.descricao;
            this.cargo.situacao = {
                id: cargo.situacao,
                label: cargo.situacao == 1 ? 'Ativo' : 'Inativo'
            };
        },
        redirectToPage() {
            const route = { name: "usuario-cargo-list"}
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
    }
};
</script>

<style lang="scss" scoped>
$padding: 5px;

#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        margin-bottom: 20px;
    }
}

</style>
